import React, { Component } from "react";
import PageHelmet from "./Helmet";
import Breadcrumb from "./Breadcrumb";
import CounterOne from "./CounterOne";
import Testimonial from "./Testimonial";
import BrandTwo from "./BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../../Layout/Main/header/Header";
import Footer from "../../../Layout/Main/footer/FooterTwo";
import { NavLink } from 'react-router-dom';
const Content = [
{
    subTitle: 'Make a checklist of your items',
    Content: 'First, make a checklist of what household items you required. Everyone"s list is different because it all depends on how much time do you have. Some people have two months for packing while some have only two weeks. So, arrange your checklist accordingly.',
    id: 1
},
{
    subTitle: 'Categorize so you can pick less',
    Content: 'A crucial packing tip is to make a list of things you do not need. You can lighten your stress and workload by sell or donate all the stuff you no longer need. Measure the new place where you are going and get rid of all furniture that will not fit in your new location.',
    id: 2
},
{
    subTitle: 'Purchase some quality moving boxes',
    Content: 'If you want to put heavy things in boxes, then buy boxes of good quality, so they do not fall apart in your hands while you are trying to move it into other places. Grocery boxes or reused boxes can be compromised due to moisture.',
    id: 3
},
{
    subTitle: 'First pack essential things',
    Content: 'When you are moving to a new place first pack the things which you needed most, because all the boxes contain the same color, so you do not mix the essential stuff.',
    id: 4
},
{
    subTitle: 'Use the color packing label.',
    Content: 'To stay organized, use the color label and put it on boxes. This moving tip can save your ton of time. You do not have to get panic for finding the important material. ',
    id: 5
},
{
    subTitle: 'Do not overload your moving box',
    Content: 'A lot of people made a massive mistake while moving; they cram all their belongings in a few boxes and overload them. As a result, the box itself unbox in your hand. Use as many boxes as you need to create easy-to-lift loads. Try to keep your most jumbo boxes to not more than fifty pounds.',
    id: 6
},
{
    subTitle: 'Use the right box for the right material',
    Content: 'Put heavy material like books in small boxes and light things in large boxes to make it easier for the mover to organize and pack all boxes in the moving truck. Make sure to put heavier items on the bottom and the lighter one on the top to avoid damaging the fragile items.',
    id: 7
},
{
    subTitle: 'Fill all the spaces in the box',
    Content: 'After putting all the material in the box, if the small spaces left then, fill that spaces with packing paper, clothing or form, peanuts, etc. Use tape at the bottom and top of the box. You can also use tape in places where stress is concentrated.',
    id: 8
},


];
class Tips extends Component{
    render(){
        let title = '11 Tips to make your packing and moving easier';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Furniture Assembly' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'Moving Tips'}   />
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                {/* <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/about-3.jpg" alt="About Images"/>
                                    </div>
                                </div> */}
                                <div className="col-lg-8 text-center">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title text-left">{title}</h2>
                                            <p className="description text-left pt--50">Most people consider moving an absolute nightmare. But it doesn't have to be. Planning ahead and doing things the right way can make your life a lot easier and make sure that your belongings get safely. The following packing tips are designed to help make your move as stress-free as possible.</p>
                                    
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Get free materials</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Many moving companies like Moonline moving offer a packing service, and some people assume that having someone else take care of the boxes and bubble wrap will lessen their stress. However, if you have the time and you begin far enough in advance, you can make things a lot simpler by packing up your own belongings. That way, you can make sure the valuables are well-wrapped, and best of all, you'll know where everything is.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Start with the special stuff.</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>You shouldn't spend money on <b>packing material</b> such as boxes and fancy wrappings from the office supply store. Go to local grocery stores and ask for empty boxes- if they don't have any on-hand, they should be able to tell you what days of the week they do. Use newspapers to wrap fragile items, or save space and wrap them in bath towels that you're going to be packing anyway. You can also ask your moving company for the <b>moving supplies</b> to avoid any hassle.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Pack by room</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Some people assume that packing similar items together is the best way to go. For example, flower vases and drinking glasses end up together because they're all made of glass and must be wrapped. A better method is to pack by room. Start in the kitchen, for example, and layer the bottom of the box with pots and pans. Then put in some glasses (wrapped in dish towels, of course), and top it off with the recipe box or some placemats. When you get to your new home, you can quickly unpack the entire kitchen without searching through multiple boxes for relevant items.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Label, label, label</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Every box should be clearly marked with the room it belongs to. This will make the unloading process easier so that if your friends or moving company are helping you move, they can simply leave the boxes in the rooms where they belong. If you prefer, you can also make a list on the outside of the box of exactly what is inside so that you'll be able to find things that much more quickly.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Pack it yourself</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Many moving companies like <NavLink to="/"><b>Moonline moving</b></NavLink> offer a packing service, and some people assume that having someone else take care of the boxes and bubble wrap will lessen their stress. However, if you have the time and you begin far enough in advance, you can make things a lot simpler by packing up your own belongings. That way, you can make sure the valuables are well-wrapped, and best of all, you'll know where everything is.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Bag it</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Using boxes for everything can take up valuable space in your moving truck, and is an unnecessary hassle. Clothing, blankets, and bed sheets don't need to go into boxes. Buy some heavy-duty trash bags and bag your soft items. The bags can be labeled with duct tape, or color-code them with different twist ties for each room of the new home.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Use what you have</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>You already have several moving containers- you don't realize it. Laundry baskets, dresser drawers, and garbage cans are excellent receptacles for moving various items. You have to move these containers anyhow, so why not fill them with something? Pack clothing in drawers and pots and pans in the kitchen trashcan. Laundry baskets are great for hauling shoes.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Plastic Wrap can protect your Furniture.</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Moving furniture with drawers is very hard. After all, they’re usually very heavy. This is why it’s a huge challenge to move them, especially if you’re going to move them out of the house to another place. In addition, there’s the issue of drawers sliding out and falling to the floor. This can severely damage the drawers, the floor, and of course, your feet. This is why you have to follow some packing tips to make sure that this isn’t going to happen when you move. The answer to this problem is simple – plastic Wrap. Just wrap plastic wrap all over the furniture, especially around the drawers. This should provide a strong enough hold so that the drawers won’t slide out of place. As a bonus, it can protect the furniture from minor scratches.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">How to Pack Heavy Items like Books</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>How do you usually pack heavy items like books? If you’re like most people, you pack these books in big boxes. Now, a book in itself is not heavy. However, dozens of books in a single box can be very heavy, presenting a lot of problems to the one carrying the box.</p>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'10px'}}>Solving this problem is very easy. In fact, it’s one of the simplest packing and moving tips. Instead of packing the books in boxes, pack them in suitcases! It makes a lot of sense. Suitcases have wheels, so when it’s time for you to move, you can use the wheels to move the books easily! It sure beats having your back broken by trying to carry a box full of books!</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left" style={{lineHeight:1.5}}>Make Sure that Kids and Pets don’t get in the Way.</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Moving can be a very chaotic process. There are boxes all over the place, and there are men moving in and out of the house. In addition, there are millions of things running in your mind. With this chaotic environment, it’s very easy to lose track of your kids and pets. One minute, they’re playing hide and seek in the boxes. The next minute, you can’t seem to locate them.</p>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'10px'}}>One of the best moving hacks to get one huge thing off of your mind is to hire a sitter. Assign the sitter to watch over the kids and the pets. This works best if you’re moving within the city. This Way, you can focus on the moving process without worrying where the kids and pets are.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Plan ahead!</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Most importantly, pack whatever you can before your actual move date rolls around. The night before your move, you should have a few essentials like a change of clothes, a toothbrush, and an alarm clock on hand- and the rest of your belongings should be packed and ready. Running around throwing things into random boxes on the day of your move can increase your stress and the likelihood of things getting lost, broken, or left behind.</p>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'10px'}}>Don't panic- moving is stressful enough. Keep it simple with these sensible packing tips, and you'll be well on your way to an easy move. If you are in Canada and want to book your move or <NavLink to="/booknow"><b>moving free quote</b></NavLink>, feel free to <NavLink to="/contact"><b>contact</b></NavLink> us</p>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 {/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--1">
                    {/* <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* End Finding Us Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        {/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="row">
                            
                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-01.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-02.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">BM. Alamin</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-03.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </React.Fragment>
        )
    }
}
export default Tips;